import { HealthTeam } from "@/@types/esus/HealthTeam";
import { HealthUnit } from "@/@types/esus/HealthUnit";
import { HomeVisit } from "@/@types/esus/HomeVisit";
import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";

export type DetailedCitizensAcsVisitsIndicatorC2Params = PaginationFilter & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	isEvaluated?: boolean;
	ine?: string;
	export?: boolean;
};

export class DetailedCitizenAcsVisitsIndicatorC2Data {
	id: number = 0;
	cpf?: string;
	cns?: string;
	birthdate: string = "";
	fullName: string = "";
	healthUnitId: number = 0;
	healthTeamId: number = 0;
	healthUnit?: HealthUnit;
	healthTeam?: HealthTeam;
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	firstAcsHomeVisit?: HomeVisit;
	firstAcsHomeVisitStatus: "finished" | "pending" | "lost" = "lost";
	secondAcsHomeVisit?: HomeVisit;
	secondAcsHomeVisitStatus: "finished" | "pending" | "lost" = "lost";
}

export async function getDetailedCitizensAcsVisitsIndicatorC2({
	uf,
	ibgeCode,
	...params
}: DetailedCitizensAcsVisitsIndicatorC2Params) {
	const response = await esusApi.get<Paginated<DetailedCitizenAcsVisitsIndicatorC2Data>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c2/detailed-citizens-home-visits`,
		params
	);
	return response.data ?? new Paginated<DetailedCitizenAcsVisitsIndicatorC2Data>();
}
